<div class="text-center">
    <div >
        <span class="material-icons-round">check_circle</span>
    </div>
    <div>
        {{translateArr.bp12}}
    </div>
</div>